import React, { memo } from "react";
import CompletionTrendChart from "./CompletionTrendChart";
import OverdueTrendChart from "./OverdueTrendChart";

const DashboardTrendCharts = ({ completionPoints = [], overdueRows = [], xAxisKey = "person", teamView = "ic" }) => (
  <div className="dashboard-trend-charts">
    <CompletionTrendChart points={completionPoints} teamView={teamView} />
    <OverdueTrendChart rows={overdueRows} xAxisKey={xAxisKey} teamView={teamView} />
  </div>
);

export default memo(DashboardTrendCharts);
